import PropTypes from 'prop-types'

// Project imports
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { useTranslation } from 'react-i18next'
import { ModalSection } from '@/shared/components/SDComponents/SDModal/styled-components'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { useStyletron } from 'baseui'
import useModalContent from '@/shared/components/FormHeader/bones/ModalContent/useModalContent'

const SubmissionModelContent = ({ submitFormModal, formSubmitted, formCanBeSubmitted, hideScript }) => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const { recordingScriptText } = useModalContent()

  const Script = () => {
    if (hideScript) {
      return null
    }

    return (
      <div className={css({ margin: '0 1rem 0' })}>
        <SDNotification type='warning' primaryText={recordingScriptText} />
      </div>
    )
  }

  return (
    <ModalSection>
      <Script />
      <SDButton
        id='modal-button-save-and-send'
        block={true}
        onClick={submitFormModal}
        isLoading={formSubmitted}
        disabled={formSubmitted || formCanBeSubmitted === false}
      >
        {t('subscriptionForm:header.modal.submit')}
      </SDButton>
    </ModalSection>
  )
}

SubmissionModelContent.propTypes = {
  submitFormModal: PropTypes.func,
  formSubmitted: PropTypes.bool,
  formCanBeSubmitted: PropTypes.bool,
  hideScript: PropTypes.bool,
}

export default SubmissionModelContent
